/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { DashboardElement } from './vi-dashboard';
import type { PanelElement } from './vi-panel';

import { AsLitHIC, BehaviorElement, HIP } from '@eab-eip/hi-component/hi-component';
import { stylesTheme } from '@eab-eip/hi-component/hi-component-theme';
import { html, LitElement, css } from 'lit-element';
import { nothing } from 'lit-html';

export const styles = css`
  :host {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--vi-panel--toolbar--background) !important;
    border-bottom: var(--hi-tile--border) !important;
    border-top-left-radius: var(--hi-tile--border-radius);
    border-top-right-radius: var(--hi-tile--border-radius);
    height: var(--hi-el--height-lrg-fx);
    padding: var(--hi-tile--padding) !important;
  }

  #toolbar__container {
    display: inline-flex;
    align-items: center;
  }

  #drag_panel__icon {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grabbing !important;
    cursor: -moz-grabbing !important;
    cursor: -webkit-grabbing !important;
  }

  #drag_panel__button {
    margin-left: var(--hi-fx-2);
  }

  #close_panel__button {
    margin-left: var(--hi-sz-4);
  }
`;

/**
 * a toolbar for buttons at the top of every panel
 */
export class PanelToolbarElement extends BehaviorElement(AsLitHIC(LitElement)) {
  static get is() {
    return 'vi-panel-toolbar';
  }

  static get styles() {
    return [stylesTheme, styles];
  }

  connectedCallback() {
    super.connectedCallback();
    this.className = 'panel__toolbar';
  }

  render() {
    const dashboardEl = this.closest('vi-dashboard') as DashboardElement;
    const panelEl = this.closest('vi-panel') as PanelElement;
    const allowDragExist = dashboardEl?.allowDrag;
    const allowRemoveExist = panelEl?.allowRemove;
    const alwaysSlotOneButton = 1;
    const buttonCountDefault = (allowDragExist ? 1 : 0) + (allowRemoveExist ? 1 : 0) + alwaysSlotOneButton;
    const buttonCount =
      getComputedStyle(this as unknown as Element).getPropertyValue('--button-count') || `${buttonCountDefault}`;
    const leftToolbarStyle = `width: calc(100% - 16px - ${buttonCount} * 24px)`;

    return html`
      <div id="toolbar__container" style=${leftToolbarStyle}>
        <slot name="left"></slot>
      </div>
      <div id="toolbar__container">
        ${allowDragExist
          ? html`<hi-button id="drag_panel__button" class="dragPanel" aesthetic="icon" size="small" bordered>
              <hi-icon id="drag_panel__icon" kind="draggable" size="small"> </hi-icon>
              <hi-hint>Drag Panel <span mixin="show-ax">(only manipulated by a mouse)</span></hi-hint>
            </hi-button>`
          : nothing}
        <slot name="right"></slot>
        <slot></slot>
        ${allowRemoveExist
          ? html` <hi-button
              id="close_panel__button"
              aesthetic="icon"
              size="small"
              bordered
              @trigger-ended=${() => panelEl.remove()}
            >
              <hi-icon id="close_panel__icon" kind="close" size="small"> </hi-icon>
              <hi-hint>Close Panel</hi-hint>
            </hi-button>`
          : nothing}
      </div>
    `;
  }
}

export default HIP.factory.element(PanelToolbarElement);
